import { DEFAULT_TIMEZONE, localNow } from "@ronin/core";

const DAY_MS = 24 * 60 * 60 * 1000;

const dayNumber = (isoDate: string) => {
  const [y = 0, m = 1, d = 1] = isoDate.split("-").map(Number);
  return Date.UTC(y, m - 1, d) / DAY_MS;
};

/** Human label for a due date/time, e.g. "Today · 18:00", "Tomorrow", "Sat 31 Oct". */
export function formatDue(
  dueDate: string,
  dueTime: string | null,
  now: Date = new Date(),
  timeZone: string = DEFAULT_TIMEZONE,
): string {
  const diff = dayNumber(dueDate) - dayNumber(localNow(now, timeZone).date);
  const relative: Record<number, string> = { [-1]: "Yesterday", 0: "Today", 1: "Tomorrow" };
  const day =
    relative[diff] ??
    new Intl.DateTimeFormat("en-GB", {
      weekday: "short",
      day: "numeric",
      month: "short",
      ...(Math.abs(diff) > 300 && { year: "numeric" }),
      timeZone: "UTC",
    }).format(new Date(dayNumber(dueDate) * DAY_MS));
  return dueTime ? `${day} · ${dueTime}` : day;
}

/** The local date `days` after today in `timeZone` (YYYY-MM-DD), for quick picks. */
export function localDatePlus(
  days: number,
  now: Date = new Date(),
  timeZone: string = DEFAULT_TIMEZONE,
): string {
  const today = dayNumber(localNow(now, timeZone).date);
  return new Date((today + days) * DAY_MS).toISOString().slice(0, 10);
}
